<template>
  <div class="map-schedule">
    <div class="map-schedule__title">Время работы отделения</div>
    <ul class="map-schedule__items">
      <li class="map-schedule__item pb-0">
        <div class="map-schedule__calendar">
          <div class="map-schedule__calendar-text">Выберите день:</div>
          <div class="calendar">
            <date-pick
              v-model="datePicker"
              :isDateDisabled="isDisabledDate"
              :callback="callback"
              :format="format"
              :parseDate="parseDate"
              :formatDate="formatDate"
              :months="months"
              :weekdays="weekdays"
            ></date-pick>
          </div>
        </div>
        <div class="map-schedule__text" v-if="actualWorkHours.status ===  stateWorkHours.holiday"
             v-html="messageAboutWork"></div>
        <div class="map-schedule__text" v-else-if="actualWorkHours.status > stateWorkHours.holiday">В этот день
          отделение работает <b v-html="`с&nbsp;${this.actualWorkHours.start}&nbsp;до&nbsp;${this.actualWorkHours.end}`"></b>
          <span v-if="this.actualWorkHours.lunchStart && this.actualWorkHours.lunchEnd"
                v-html="`, перерыв&nbsp;<b>с&nbsp;${this.actualWorkHours.lunchStart}&nbsp;до&nbsp;${this.actualWorkHours.lunchEnd }</b>`">
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import fecha, { setGlobalDateI18n } from 'fecha';
import moment from 'moment';
import locale from 'element-ui/lib/locale';
import lang from '../addons/ru-RU';
import DatePick from '../addons/vueDatePick/vueDatePick.vue';
import 'vue-date-pick/dist/vueDatePick.css';

setGlobalDateI18n({
  dayNamesShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  monthNames: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
});

locale.use(lang);

moment.locale('ru');
const weekDayName = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export default {
  name: 'BranchWorkSchedule',
  props: {
    odp: Object,
  },
  computed: {
    actualWorkHours() {
      if (this.temporaryHoliday) {
        return {
          status: this.stateWorkHours.holiday,
          start: null,
          end: null,
        };
      } if (this.temporaryWorkHours && this.temporaryWorkHours.start && this.temporaryWorkHours.end) {
        return {
          status: this.stateWorkHours.general,
          start: this.temporaryWorkHours.start,
          end: this.temporaryWorkHours.end,
          lunchStart: this.temporaryWorkHours.lunchStart,
          lunchEnd: this.temporaryWorkHours.lunchEnd,
        };
      } if (this.currentHoliday) {
        return {
          status: this.stateWorkHours.holiday,
          start: null,
          end: null,
        };
      } if (this.currentWeekDay && this.currentWeekDay.start && this.currentWeekDay.end) {
        return {
          status: this.stateWorkHours.general,
          start: this.currentWeekDay.start,
          end: this.currentWeekDay.end,
          lunchStart: this.currentWeekDay.lunchStart,
          lunchEnd: this.currentWeekDay.lunchEnd,
        };
      }
      return {
        status: this.stateWorkHours.closed,
        start: null,
        end: null,
      };
    },
    isWorkTimeChangesEmpty() {
      try {
        if (!this.odp.workTimeChanges || !this.odp.workTimeChanges[this.currentChangeDate]) {
          return false;
        }
        return !(Object.values(this.odp.workTimeChanges[this.currentChangeDate])
          .find((item) => (item !== '' && item !== null)));
      } catch (e) {
        console.error(e);
        return false;
      }
    },
  },
  components: {
    DatePick,
  },
  methods: {
    parseDate(dateString) {
      return moment(dateString, this.format).toDate();
    },
    formatDate(dateObj, format) {
      return fecha.format(dateObj, format);
    },
    callback(date) {
      this.currentChangeDate = moment(date.date).format().slice(0, 10);
      this.dateWeekName = weekDayName[moment(date.date).isoWeekday() - 1];
    },
    isFutureDate(date) {
      const currentDate = new Date();
      return date > currentDate;
    },
    isDisabledDate(date) {
      const currentDate = new Date();
      const storageDate = moment().add(7, 'day');

      currentDate.setDate(currentDate.getDate() - 1);

      return currentDate > date || storageDate < date;
    },
    updateSchedule() {
      if (this.odp.workTimeChanges
        && ((this.odp.workTimeChanges[this.currentChangeDate] === null) || this.isWorkTimeChangesEmpty)) {
        this.temporaryHoliday = true;
      } else if (this.odp.workTimeChanges && this.odp.workTimeChanges[this.currentChangeDate]) {
        this.temporaryHoliday = false;
        this.temporaryWorkHours = this.odp.workTimeChanges[this.currentChangeDate];
      } else {
        this.temporaryWorkHours = null;
        this.temporaryHoliday = false;
      }
      if (this.odp.workTime && this.odp.workTime[this.dateWeekName]) {
        this.currentHoliday = false;
        this.currentWeekDay = this.odp.workTime[this.dateWeekName];
      } else if (this.odp.workTime && this.odp.workTime[this.dateWeekName] === null) {
        this.currentHoliday = true;
      }
    },
  },
  watch: {
    odp() {
      if (this.odp.address !== this.oldOdpAddress) {
        this.temporaryWorkHours = null;
        this.currentWeekDay = null;
        this.temporaryHoliday = false;
        this.currentHoliday = false;
      }
    },
  },
  mounted() {
    if (this.odp) {
      this.updateSchedule();
    }
  },
  updated() {
    if (this.odp) {
      this.oldOdpAddress = this.odp.address;
      this.updateSchedule();
    }
  },
  data() {
    return {
      format: 'DD MMMM, ddd             '
        + '                         YYYY',
      datePicker: fecha.format(new Date(), 'DD MMMM, ddd'),
      currentDate: moment().format('DD MMMM'),
      dateWeekName: weekDayName[moment().isoWeekday() - 1],
      currentWeekDay: null,
      temporaryWorkHours: null,
      oldOdpAddress: null,
      currentHoliday: false,
      temporaryHoliday: false,
      currentChangeDate: moment().format().slice(0, 10),
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель',
        'Май', 'Июнь', 'Июль', 'Август',
        'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
      ],
      weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
      messageAboutWork: 'В&nbsp;этот день отделение не&nbsp;работает',
      stateWorkHours: {
        holiday: 1,
        general: 2,
        closed: -1,
      },
    };
  },
};
</script>
